import { render, staticRenderFns } from "./DashInventoryFileReview.vue?vue&type=template&id=082245b9&scoped=true&"
import script from "./DashInventoryFileReview.vue?vue&type=script&lang=js&"
export * from "./DashInventoryFileReview.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryFileReview.vue?vue&type=style&index=0&id=082245b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082245b9",
  null
  
)

export default component.exports